import {
    checkIfUnder18,
    checkIfValidDate,
    validateDateOfBirthComponents
} from "utils/studentVerificationUtilsV3";
import SheerId from "services/SheerId";
import isEmpty from "lodash.isempty";
import assign from "lodash.assign";
import { setThinking, doneThinking } from "./thinking";
import { setErrorInErrors, clearErrorFromErrors } from "utils/errorsUtil";
import ERROR_MESSAGES from "common/constants/ErrorMessages";
import { LOCATION_CHANGE } from "react-router-redux";
import { SCREENS } from "common/constants/Constants";
import { browserHistory } from "react-router";
import querystring from "querystring";
import appPath from "../utils/appPath";

// Actions (must be name-spaced for reducer)

export const STUDENT_FORM_SET_COUNTRY = "STUDENT_FORM_SET_COUNTRY";
export const STUDENT_FORM_SET_BIRTH_YEAR = "STUDENT_FORM_SET_BIRTH_YEAR";
export const STUDENT_FORM_SET_BIRTH_MONTH = "STUDENT_FORM_SET_BIRTH_MONTH";
export const STUDENT_FORM_SET_BIRTH_DAY = "STUDENT_FORM_SET_BIRTH_DAY";
export const STUDENT_FORM_SET_FIRST_NAME = "STUDENT_FORM_SET_FIRST_NAME";
export const STUDENT_FORM_SET_LAST_NAME = "STUDENT_FORM_SET_LAST_NAME";
export const STUDENT_FORM_SET_SCHOOL_INFO = "STUDENT_FORM_SET_SCHOOL_INFO";
export const STUDENT_FORM_SET_STUDENT_ID = "STUDENT_FORM_SET_STUDENT_ID";
export const STUDENT_FORM_SET_ERROR = "STUDENT_FORM_SET_ERROR";
export const STUDENT_FORM_CLEAR_ERROR = "STUDENT_FORM_CLEAR_ERROR";
export const STUDENT_FORM_SET_IS_DOC_UPLOAD = "STUDENT_FORM_SET_IS_DOC_UPLOAD";

// Reducer

const DEFAULT_STATE = {
    country: "",
    firstName: "",
    lastName: "",
    birthYear: "",
    birthMonth: "",
    birthDay: "",
    studentId: "",
    schoolInfo: {},
    errors: {}
};

export function studentFormReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case STUDENT_FORM_SET_COUNTRY:
            return assign({}, state, { country: action.country });
        case STUDENT_FORM_SET_BIRTH_YEAR:
            return assign({}, state, { birthYear: action.birthYear });
        case STUDENT_FORM_SET_BIRTH_MONTH:
            return assign({}, state, { birthMonth: action.birthMonth });
        case STUDENT_FORM_SET_BIRTH_DAY:
            return assign({}, state, { birthDay: action.birthDay });
        case STUDENT_FORM_SET_FIRST_NAME:
            return assign({}, state, { firstName: action.firstName });
        case STUDENT_FORM_SET_LAST_NAME:
            return assign({}, state, { lastName: action.lastName });
        case STUDENT_FORM_SET_SCHOOL_INFO:
            return assign({}, state, { schoolInfo: action.schoolInfo });
        case STUDENT_FORM_SET_STUDENT_ID:
            return assign({}, state, { studentId: action.studentId });
        case STUDENT_FORM_SET_IS_DOC_UPLOAD:
            return assign({}, state, {
                isDocUpload: true,
                studentId: action.studentId,
                redirectTo: action.redirectTo
            });
        case STUDENT_FORM_SET_ERROR:
            return assign({}, state, {
                errors: setErrorInErrors(state.errors, action.error)
            });
        case STUDENT_FORM_CLEAR_ERROR:
            return assign({}, state, {
                errors: clearErrorFromErrors(state.errors, action.errorType)
            });
        case LOCATION_CHANGE:
            return assign({}, DEFAULT_STATE, {
                isDocUpload: state.isDocUpload,
                studentId: state.studentId,
                redirectTo: state.redirectTo
            });
        default:
            return state;
    }
}

// Action Creators

export function updateCountry(country) {
    return {
        type: STUDENT_FORM_SET_COUNTRY,
        country
    };
}

export function updateFirstName(firstName) {
    return {
        type: STUDENT_FORM_SET_FIRST_NAME,
        firstName
    };
}

export function updateLastName(lastName) {
    return {
        type: STUDENT_FORM_SET_LAST_NAME,
        lastName
    };
}

export function setStudentId(studentId) {
    return {
        type: STUDENT_FORM_SET_STUDENT_ID,
        studentId
    };
}

export function updateSchoolInfo(schoolInfo) {
    return {
        type: STUDENT_FORM_SET_SCHOOL_INFO,
        schoolInfo
    };
}

export function setError(error) {
    return {
        type: STUDENT_FORM_SET_ERROR,
        error
    };
}

export function clearError(errorType) {
    return {
        type: STUDENT_FORM_CLEAR_ERROR,
        errorType
    };
}

export function setDocUpload(studentId, redirectTo) {
    return {
        type: STUDENT_FORM_SET_IS_DOC_UPLOAD,
        studentId,
        redirectTo
    };
}

export function validateStudent() {
    return (dispatch, getState) => {
        const {
            loginRegister: {
                email
            },
            studentForm: {
                firstName,
                lastName,
                birthYear,
                birthMonth,
                birthDay,
                schoolInfo
            }
        } = getState();

        dispatch(clearError("global"));
        dispatch(validateBirthDate(birthYear, birthMonth, birthDay));
        dispatch(validateFirstName(firstName));
        dispatch(validateLastName(lastName));
        dispatch(validateSchoolInformation(schoolInfo));

        const {
            studentForm: {
                errors
            }
        } = getState();

        if (!isEmpty(errors)) {
            return Promise.resolve(false);
        }

        return dispatch(validateStudentInfo(email, {
            id: schoolInfo.id,
            firstName,
            lastName,
            dateOfBirth: `${ birthYear }-${ birthMonth }-${ birthDay }`
        }));
    };
}

export function validateStudentInfo(email, params) {
    return (dispatch) => {
        const { origin, pathname, search } = window.location;
        const { id: ratePlanId, verificationId } = querystring.parse(search.substring(1));
        const redirectUrl = `${ origin }${ pathname }?id=${ ratePlanId }`;

        if (verificationId && verificationId.length === 24) {
            // trust it for now, fix properly in ENG4SUBS-2106
            dispatch(setStudentId(verificationId));

            return Promise.resolve(true);
        }

        dispatch(setThinking());

        return SheerId.validateStudentInfo(email, params, redirectUrl).then((response) => {
            if (!response.valid) {
                dispatch(setDocUpload(response.verificationId, redirectUrl));
                browserHistory.push(appPath(SCREENS.STUDENT_DOCUMENT_UPLOAD));

                return false;
            }

            dispatch(setStudentId(response.verificationId));

            return true;
        }).catch(() => {
            dispatch(setError({
                type: "global", message: ERROR_MESSAGES.SERVICE_ERROR
            }));

            return false;
        }).finally(() => {
            dispatch(doneThinking());
        });
    };
}

export function validateSchoolInformation(schoolInfo) {
    return (dispatch) => {
        if (!schoolInfo || !schoolInfo.id) {
            dispatch(setError({ type: "schoolInfo", message: ERROR_MESSAGES.MISSING_SCHOOL }));

            return;
        }

        dispatch(clearError("schoolInfo"));
    };
}

export function updateBirthYear(birthYear) {
    return {
        type: STUDENT_FORM_SET_BIRTH_YEAR,
        birthYear
    };
}

export function updateBirthMonth(birthMonth) {
    return {
        type: STUDENT_FORM_SET_BIRTH_MONTH,
        birthMonth
    };
}

export function updateBirthDay(birthDay) {
    return {
        type: STUDENT_FORM_SET_BIRTH_DAY,
        birthDay
    };
}

export function validateBirthDate(birthYear, birthMonth, birthDay) {
    return (dispatch) => {
        if (!checkIfValidDate(birthYear, birthMonth, birthDay)) {
            dispatch(setError({ type: "birthDate", message: ERROR_MESSAGES.INVALID_DATE_OF_BIRTH }));

            return;
        }

        if (checkIfUnder18(birthYear, birthMonth, birthDay)) {
            dispatch(setError({ type: "birthDate", message: ERROR_MESSAGES.UNDER_18 }));

            return;
        }

        dispatch(clearError("birthDate"));
    };
}

export function validateBirthDateFormat() {
    return (dispatch, getState) => {
        const {
            studentForm: {
                birthYear,
                birthMonth,
                birthDay
            }
        } = getState();

        if (!validateDateOfBirthComponents(birthYear, birthMonth, birthDay)) {
            return;
        }

        dispatch(validateBirthDate(birthYear, birthMonth, birthDay));
    };
}

export function validateFirstName(firstName) {
    return (dispatch) => {
        if (!firstName) {
            dispatch(setError({ type: "firstName", message: ERROR_MESSAGES.MISSING_FIRST_NAME }));

            return;
        }

        dispatch(clearError("firstName"));
    };
}

export function validateLastName(lastName) {
    return (dispatch) => {
        if (!lastName) {
            dispatch(setError({ type: "lastName", message: ERROR_MESSAGES.MISSING_LAST_NAME }));

            return;
        }

        dispatch(clearError("lastName"));
    };
}

export default {
    studentFormReducer,
    validateStudent,
    validateStudentInfo,
    validateSchoolInformation,
    validateBirthDate,
    validateBirthDateFormat,
    validateFirstName,
    validateLastName,
    updateCountry,
    updateSchoolInfo,
    updateBirthYear,
    updateBirthMonth,
    updateBirthDay,
    updateFirstName,
    updateLastName,
    setStudentId,
    setError,
    clearError
};
